// 删除账号 真正删除 1

require("clover/panel/component/common/UIGroupButton")

let AccountRealDelPanel = xClass("AccountRealDelPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "packed/logout.pack"
)
AccountRealDelPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
AccountRealDelPanel.preloadResPromise = function (useMask = false) {
    return preloadWithLoadingPromise(RES, useMask)
}
let _instance = null
AccountRealDelPanel.getInstance = function () {
    let self = this
    return _instance
}
AccountRealDelPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self
    self.aManager = AccountManager.getInstance()
    self.aManager.dcRealDelPanelOpen()
    self.initUI();
}
AccountRealDelPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
AccountRealDelPanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {}

AccountRealDelPanel.prototype.startDel = function () {
    let self = this
    // self.delTime = 3

    // self.lastTimeTask = setInterval(() => {

    // }, 1000);
    self.aManager.delAccount(() => {
        this.onClose();
        this.isbusy = false
        self.aManager.showStopUsePanel()
    }, () => {
        this.isbusy = false
    })
}
AccountRealDelPanel.prototype.initUI = function () {
    let self = this
    self.mainNode = cc.CSLoader.createNode("cocos/logout_logout_unregistration.csb")
    self.addChild(self.mainNode);

    this.btnClose = self.mainNode.getChildByName("close");
    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
    }, true);

    self.mainNode.getChildByName("inputname").setVisible(false)
    this.mainNode.getChildByName("tittle_lab").setString("账号删除确认")


    this.btnConfirm = self.mainNode.getChildByName("button");
    quickBuildBtn(this.btnConfirm, UIGroupButton, PushBounceAnim, () => {
        if (this.isbusy) return
        this.isbusy = true
        self.aManager.dcRealDelPanelClick()
        self.startDel()
        // self.aManager.delAccount(()=>{
        //     this.onClose();
        //     this.isbusy = false
        //     self.aManager.showStopUsePanel()
        // },()=>{
        //     this.isbusy = false
        // })
    }, true);


    let updateBtn = (flag) => {
        if (flag) {
            this.btnConfirm.getChildByName("txt").setVisible(true)
            this.btnConfirm.getChildByName("txt2").setVisible(false)
        } else {
            this.btnConfirm.getChildByName("txt").setVisible(false)
            this.btnConfirm.getChildByName("txt2").setVisible(true)
        }
        this.btnConfirm.setEnabled(flag);
    }
    updateBtn(false)

    var textInput = ccui.EditBox.create(cc.size(400, 60), "uilibrary/inputname.png", 1)
    self.addChild(textInput)
    textInput.setMaxLength(30)
    textInput.setReturnType(1)
    textInput.setInputMode(1)
    textInput.setFont("Arial", 30)
    textInput.setFontColor(cc.c4b(255, 0, 0, 255))
    textInput.setAnchorPoint(0, 0.5)
    // textInput.setPlaceholderFontSize(20)
    // textInput.setPlaceHolder("请输入文本内容")

    textInput.setPosition(-200, -43)

    let placeHolderLabel = cc.Label.createWithSystemFont("请输入文本内容", "Arial", 30)
    placeHolderLabel.setColor(cc.color(175, 175, 175, 255))
    placeHolderLabel.setPosition(10, 10)
    placeHolderLabel.setAnchorPoint(0,0)
    textInput.addChild(placeHolderLabel)
    let delete_button_text = MetaManager.getDeleteAccountConfig().delete_button_text || ""

    textInput.registerScriptEditBoxHandler(function (event) {
        if (!self.nodeExist) {
            return
        }
        let str = textInput.getString() || ""
        if (str == delete_button_text) {
            // self.btnConfirm.setEnabled(true);
            updateBtn(true)
        } else {
            // self.btnConfirm.setEnabled(false);
            updateBtn(false)
        }
        if (event === "ended" && str == "") {
            placeHolderLabel.setVisible(true)
        }
        if (event == "began"){
            placeHolderLabel.setVisible(false)
        }
    })
    // textInput._placeholderText.setAnchorPoint(0, 0.5)
    // textInput.setPosition(size.width / 2 - 200, -145)


    self.mainNode.getChildByName("txt3").setVisible(false)

    // let tipStr= "如您完全理解删除账号的影响，请输入{c=155,91,63,255/c}“{delete_button_text}”{c=215,42,31,255/c}并点击确认删除{c=155,91,63,255/c}"
    let tipStr = getText("delete.page4.text2")
    
    tipStr = tipStr.replace("{delete_button_text}", delete_button_text);
    let colorLabel = getColorTextH5(tipStr, 20, 20)
    colorLabel.x = -colorLabel.width / 2
    colorLabel.y = 50
    self.mainNode.addChild(colorLabel)

    this.initShowUI()
}

AccountRealDelPanel.prototype.initShowUI = function () {
    let self = this
    self.mainNode.getChildByName("txt1").setVisible(false)
    // let contentStr = "1.删除完毕后，您将无法再次登录、使用该游戏账号\n2.游戏内虚拟资产和关卡数据等删除后将无法恢复\n3.删除成功后无法重新恢复账号"
    let contentStr = getText("delete.page4.text1")
    let showLabel = cc.Label.createWithSystemFont(contentStr, "Arial", 22)
    showLabel.setColor(cc.color(155, 91, 63, 255))
    showLabel.setDimensions(400, 0)
    showLabel.setAnchorPoint(0,1)

    // self.mainNode.getChildByName("txt1").setString(contentStr)
    // self.mainNode.getChildByName("txt1").getVirtualRenderer().setLineHeight(30)
    // self.mainNode.getChildByName("txt1").y = 170
    // self.mainNode.getChildByName("txt1").setAnchorPoint(0.5, 1)
      // 初始化列表
      let size = cc.size(400,200)
      let scrollView = ccui.ScrollView.create()
      scrollView.setAnchorPoint(0.5,0.5)
      scrollView.setDirection(ccui.ScrollViewDir.vertical)
      scrollView.setContentSize(size.width + 50, size.height)
      scrollView.setClippingEnabled(true)
      scrollView.setBounceEnabled(true)
      self.scrollView = scrollView
      this.addChild(scrollView)
      self.scrollView.y = 190


      showLabel.x = 25
      showLabel.y = size.height - 10

      self.scrollView.addChild(showLabel)


}
module.exports = AccountRealDelPanel